import { makeStyles } from '@material-ui/core';
export default makeStyles((theme) => ({
  kycDetails: {
    padding: '50px 170px 35px',
    '@media (max-width: 1125px)': {
      padding: '50px 5% 35px',
    },
    '@media (max-width: 1024px)': {
      padding: '0px 5% 35px',
    },
    '@media (max-width: 767px)': {
      padding: '0px 5% 15px',
    },
  },
  investNowFormHeader: {
    fontSize: 32,
    letterSpacing: 0.3,
    color: theme.palette.warning.contrastText,
    marginBottom: 35,
    fontWeight: 400,
    '@media (max-width: 525px)': {
      fontSize: 20,
      margin: '0px 0 20px',
    },
  },
  fundingTypeText: {
    fontSize: 18,
    letterSpacing: 0.3,
    color: theme.palette.warning.contrastText,
    marginBottom: 25,
    marginTop: 45,
    fontWeight: 700,
    '@media (max-width: 767px)': {
      textAlign: 'center',
    },
    '@media (max-width: 525px)': {
      fontSize: 17,
      margin: '20px 0',
    },
  },
  //Custom Switch Style
  switchBox: {
    '@media (max-width: 767px)': {
      textAlign: 'center',
    },
    marginBottom: 25,
  },
  switchRoot: {
    width: '217px',
    height: '42px',
    padding: '0px',
  },
  switchBase: {
    color: '#818181',
    padding: '1px',
    '&$checked': {
      '& + $track': {
        backgroundColor: '#E5E5E5',
      },
      '& $thumb:after': {
        content: "'Entity'",
      },
    },
    '&$disabled + $track': {
      backgroundColor: '#E5E5E5',
      opacity: 0.5,
    },
    '&.MuiSwitch-colorSecondary.Mui-disabled + .MuiSwitch-track': {
      backgroundColor: '#E5E5E5',
      opacity: '0.5 !important',
    },
  },
  thumb: {
    color: theme.palette.secondary.main,
    width: '106px',
    height: '42px',
    margin: '-1px',
    borderRadius: 31,
    '&:after': {
      color: theme.palette.common.white,
      fontSize: 14,
      fontWeight: 700,
      position: 'absolute',
      top: 12,
      right: 35,
      left: 20,
      content: "'Individual'",
    },
  },
  track: {
    borderRadius: '31px',
    backgroundColor: '#E5E5E5',
    opacity: '1 !important',
    '&:after, &:before': {
      color: 'black',
      fontSize: 14,
      fontWeight: 700,
      position: 'absolute',
      top: 12,
    },
    '&:after': {
      content: "'Individual'",
      left: 20,
    },
    '&:before': {
      content: "'Entity'",
      right: 35,
    },
  },
  checked: {
    color: '#FF6829 !important',
    transform: 'translateX(110px) !important',
  },
  //Custom Switch Style
}));
